import { Card, CardContent, Radio, Stack, Typography } from "@mui/material";
import type { SSOAccessRole } from "Components/Onboarding/SSO/types";

type Props = {
  value: SSOAccessRole;
  label: string;
  description: string;
  selected: boolean;
  onChange: (value: SSOAccessRole) => void;
};

export const RoleSelectionCard = ({
  value,
  label,
  description,
  selected,
  onChange,
}: Props) => (
  <Card
    component="button"
    onClick={() => onChange(value)}
    sx={{
      cursor: "pointer",
      textAlign: "left",
      border: selected ? "2px solid" : "1px solid",
      p: selected ? "0px" : "1px",
      borderColor: selected ? "primary.main" : "divider",
      backgroundColor: "background.paper",
      "&:hover": {
        borderColor: "primary.main",
        backgroundColor: "action.hover",
      },
    }}
  >
    <CardContent>
      <Stack direction="row" alignItems="flex-start" spacing={[1, 2]}>
        <Radio checked={selected} onChange={() => onChange(value)} />
        <Stack flex={1}>
          <Typography variant="h6" component="h3" gutterBottom>
            {label}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);
